import React from "react";
import {FormattedMessage} from "react-intl";

import {blueColor} from "../../../../../../assets/jss/main";

const styles = {
    orderId: {
        fontWeight: 600,
        color: blueColor,
    },
};

export default function PriceChangeLog({item}) {
    return (
        <FormattedMessage
            id="picking.order.show.note.automaticLog.priceChange"
            values={{
                reference: <span style={styles.orderId}>{item.lineItem?.name}</span>,
            }}
        />
    );
}
